// components/GuidelineLink.tsx
import React from "react";
import { Info } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogHeader } from "~/components/ui/dialog";
import { Button } from "~/components/ui-custom/button";
import type { I18NFunction } from "~/lib/form/form-config-types";
import { useI18n } from "~/hooks/use-i18n";

const GUIDELINES = [
  {
    href: "https://www.nccn.org/guidelines/category_1",
    label: "NCCN® Guidelines - Skin (CSCC/BCC)",
  },
  {
    href: "https://www.facs.org/quality-programs/cancer-programs/american-joint-committee-on-cancer/version-9/",
    label: "AJCC 9th Edition Staging Manual",
  },
  {
    href: "https://www.astro.org/provider-resources/guidelines/skin-cancer-guideline?utm",
    label: "ASTRO Clinical Practice Guideline - Skin Cancer",
  },
  {
    href: "https://www.actasdermo.org/en-linkresolver-rf-brigham-women-s-S0001731022009310",
    label: "Brigham & Women's / RF Skin Cancer Staging",
  },
];

type Props = {
  /** Whatever you pass becomes the trigger (defaults to an info icon). */
  children?: React.ReactNode;
};

export const GuidelineLink: React.FC<Props> = ({ children }) => {
  const { l } = useI18n();
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-secondary-700 underline">{children}</button>
      </DialogTrigger>

      <DialogContent className="max-w-xl" aria-label="Guideline links">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">
            {l(
              "Key Guidelines for High-Risk / Advanced NMSC",
              "Lignes directrices principales pour les NMSC de haut risque / avancés"
            )}
          </DialogTitle>
        </DialogHeader>

        <ul className="space-y-3 mt-4">
          {GUIDELINES.map((g) => (
            <li key={g.href}>
              <a
                href={g.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 underline hover:text-primary-700 focus-visible:ring-2 focus-visible:ring-primary-500 rounded"
              >
                {g.label}
              </a>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
